module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/assign-e0f29c2330998d0065311116de3eb9ce.svg";